module.exports = __webpack_public_path__ + "static/media/road1.d503f2a3.png";